import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitShortener'
})
export class UnitShortenerPipe implements PipeTransform {

  private unitMap: { [key: string]: string } = {
    'Kilogram': 'Kg',
    'Liter': 'L',
    'Pieces': 'Pcs',
    'Milliliter': 'mL',
    'Gram': 'g',
    // Add more mappings as needed
  };

  transform(value: string): string {
    return this.unitMap[value] || value;
  }

}
